var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGekoFullLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 36,
    viewBox: "0 0 160 36",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Geko Wallet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Geko Wallet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 160,
    height: 36
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Segoe UI, Roboto, Helvetica, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    dominantBaseline: "middle",
    transform: "translate(0,18)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fill: "#c89f54"
  }, "GEKO"), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 0,
    fill: "#ffffff"
  }, "WALLET"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGekoFullLogo);
export default __webpack_public_path__ + "static/media/geko_full_logo.04a653ae4425e0d198db992e1afbb682.svg";
export { ForwardRef as ReactComponent };